import Chip from "@mui/material/Chip";

// Formatação e chips compartilhados entre a lista e a visualização
// de Itens de Cobrança.

export const priceFmt = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const STATUS: Record<string, { label: string; color: "success" | "default" }> =
  {
    active: { label: "Ativo", color: "success" },
    inactive: { label: "Inativo", color: "default" },
  };

export function ProductStatusChip({ status }: { status?: string }) {
  const chip = (status && STATUS[status]) || {
    label: status || "—",
    color: "default" as const,
  };
  return <Chip size="small" color={chip.color} label={chip.label} />;
}
